import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TimeUnit} from "@data/enums/data.enums";

@Component({
  selector: 'ag-time-scale-picker',
  templateUrl: './ag-time-scale-picker.component.html',
  styleUrls: ['./ag-time-scale-picker.component.scss']
})
export class AgTimeScalePickerComponent implements OnInit {

  @Input() label: string = "Scale";
  @Input() initialScaleValue: TimeUnit | undefined;
  timeUnitValues: TimeUnit[] = Object.values(TimeUnit).filter(value => value != TimeUnit.SECOND);
  selectedValue: TimeUnit | undefined ;
  @Output() selectionChange :EventEmitter<TimeUnit>= new EventEmitter();

  onScaleChanged(selectedValue: TimeUnit): void {
    this.selectedValue = selectedValue;
    this.selectionChange.emit(selectedValue)
  }

  ngOnInit() {
    if(this.initialScaleValue) this.selectedValue = this.initialScaleValue
  }
}
